/**
 * Ernaehrung auf dem Bereichs-Board (F-35 E, F-01): heute Energie, Eiweiss
 * und Trinken gegen das Ziel, dazu der Score-Schnitt der Woche. Erscheint nur
 * im gewaehlten Ernaehrungs-Bereich.
 */
import { Link } from 'react-router-dom';

import type { ID } from '@/domain/types';
import { today } from '@/lib/datetime';
import { useErnaehrungHeute } from '@/modules/ernaehrung/useErnaehrungHeute';
import { ZielBalken } from '@/modules/ernaehrung/Tagesuebersicht';
import { ScoreZahl } from '@/modules/ernaehrung/analyse/ScoreKarte';

export function BereichErnaehrung({ areaId, immer }: { areaId: ID; /** Auf der Seite von "Gesundheit & Körper" immer zeigen. */ immer?: boolean }) {
  const d = useErnaehrungHeute(today());
  if (!d || (!immer && d.einstellungen?.bereichId !== areaId)) return null;
  const { zeile } = d;
  return (
    <section aria-label="Ernährung" className="flex flex-col gap-2 rounded-lg border border-line bg-surface px-4 py-3.5">
      <div className="flex items-center gap-2">
        <h2 className="flex-1 text-sm font-semibold">Ernährung heute</h2>
        <Link to="/ernaehrung" className="text-[12px] text-accent-text hover:underline">Zur Ernährung</Link>
      </div>
      <ZielBalken k="kcal" label="Energie" wert={zeile.summe.werte.kcal} ziel={zeile.ziele.kcal} einheit="kcal" />
      <ZielBalken k="eiweiss" label="Eiweiß" wert={zeile.summe.werte.eiweiss} ziel={zeile.ziele.eiweiss} einheit="g" />
      <ZielBalken k="wasserMl" label="Trinken" wert={zeile.wasserMl} ziel={zeile.ziele.wasserMl} einheit="ml" />
      <div className="flex items-center gap-2 text-[12px] text-ink-muted">
        <ScoreZahl wert={d.schnitt} /> <span>Ø Score diese Woche{d.tage ? ` (${d.tage} ${d.tage === 1 ? 'Tag' : 'Tage'})` : ' – noch kein vollständiger Tag'}</span>
        <Link to="/ernaehrung/analyse" className="ml-auto text-accent-text hover:underline">Analyse</Link>
      </div>
    </section>
  );
}
